export default "__VITE_ASSET__5ph3bqoi__"